import { render } from "./Detail.vue?vue&type=template&id=489842d5&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=489842d5&lang=less&scoped=true"

import exportComponent from "/Users/jonnorth/VueCloud/cloud-market/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489842d5"]])

export default __exports__